import { useParams, useSearchParams } from "react-router-dom";
import BackButton from "../../components/BackButton";
import SizingChartsMockBanner from "../../components/setup/SizingChartsMockBanner";
import SizingChartEditorForm from "../../components/setup/SizingChartEditorForm";
import {
  DEFAULT_CHART_PARAM,
  LINGERIE_CHART_PARAM,
} from "../../types/types";

export default function EditSizingChart() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const raw = searchParams.get("categoryParam");
  const categoryParam =
    raw === LINGERIE_CHART_PARAM ? LINGERIE_CHART_PARAM : DEFAULT_CHART_PARAM;
  const isPreview = searchParams.get("preview") === "1";

  return (
    <div className="container">
      <div className="flex items-center gap-2 mb-8">
        <BackButton className="mr-2" defaultPath="/sizing-charts" />
        <h1 className="page-title mb-0">
          {isPreview ? "View Sizing Chart" : "Edit Sizing Chart"}
        </h1>
      </div>
      <SizingChartsMockBanner />
      <SizingChartEditorForm
        categoryParam={categoryParam}
        routeChartId={id}
        mode={isPreview ? "preview" : "edit"}
      />
    </div>
  );
}
